import '../../assets/wb-icons/style.css';
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

export type WBIconProps = Omit<React.ComponentProps<'i'>, 'ref'> & {
  name: string;
};

const WBIcon = styled(
  React.forwardRef<HTMLDivElement, WBIconProps>(
    ({name, className, ...standardProps}, ref) => {
      return (
        <i
          {...standardProps}
          ref={ref}
          className={classNames(`wbic-ic-${name}`, className)}></i>
      );
    }
  )
)``;
export default WBIcon;
